import { Component, OnInit } from '@angular/core';
import { RunCorrespondenceTasksService } from 'app/services/run-correspondence-tasks.service';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';

@Component({
  selector: 'app-run-correspondence-tasks',
  templateUrl: './run-correspondence-tasks.component.html',
  styleUrls: ['./run-correspondence-tasks.component.scss']
})
export class RunCorrespondenceTasksComponent implements OnInit {
  public lblHeading = 'Run Correspondence Tasks';

  public isReportVisible = false;
  public isExpiredReportVisible = false
  public isNotreturnedReportVisible = false
  public isFeesDueVisible = false;
  public isApprovedPermitsVisible = false;
  public isInvoicePermitsVisible: boolean = false;
  public isFirstComplianceReport: boolean = false;
  public isSecondComplianceReport: boolean = false;
  public isThirdComplianceReport: boolean = false;
  public isMonthyComplianceReturn: boolean = false;
  public isMonthyComplianceNew: boolean = false;
  public isAnnualComplianceRecords:boolean = false;
  public isAnnualComplianceReminders:boolean = false;
  public isAnnualComplianceInvoices:boolean = false;
  public isMonthlyComplianceRecords:boolean = false;
  public isMonthlyComplianceReminders:boolean = false;
  
  public ExpiringReport: any;
  public ExpiredgReport: any;
  public NotReturnedReport: any;
  public FeesDueTReport: any;
  public ApprovedPermitsReport: any;
  public InvoicePermitsReport: any;
  public FirstComplianceReport: any;
  public SecondComplianceReport: any;
  public ThirdComplianceReport: any;
  public ComplianceReturnReport: any;
  public ComplianceReturnNewReport: any;
  public AnnualComplianceRecordsReport: any;
  public AnnualComplianceRemindersReport: any;
  public AnnualComplianceInvoicesReport: any;
  public MonthlyComplianceReport: any;

  public message = "Processing...";

  public isLoading = false;
  constructor(
    private service: RunCorrespondenceTasksService,
    public complianceservice: CompliancereturnsService
  ) { }

  ngOnInit() {
  }
  runExiryCheckTask() {
    this.isLoading = true;
    this.service.CreatePermitsExpiryReminder().subscribe(data => {
      this.isLoading = false;
      this.ExpiringReport = data;
      this.isReportVisible = true;
    });
  }
  runExpiredCheckTask() {
    this.isLoading = true;
    this.service.CreatePermitsExpiredReminder().subscribe(data => {
      this.isLoading = false;
      this.ExpiredgReport = data;
      this.isExpiredReportVisible = true;
    });
  }
  runNotReturnedCheckTask() {
    this.isLoading = true;
    this.service.CreatePermitsNotReturnedReminders().subscribe(data => {
      this.isLoading = false;
      this.NotReturnedReport = data;
      this.isNotreturnedReportVisible = true;
    });
  }
  runFeesDueTask() {
    this.isLoading = true;
    this.service.CreateMessagesForFeesDue().subscribe(data => {
      this.isLoading = false;
      this.FeesDueTReport = data;
      this.isFeesDueVisible = true;
    });
  }
  runApprovedPermitsTask() {
    this.isLoading = true;
    this.service.CreateApprovedPermitsNeedingConfirm().subscribe(data => {
      this.isLoading = false;
      this.ApprovedPermitsReport = data;
      this.isApprovedPermitsVisible = true;
    });
  }
  runInvoicePermitsTask() {
    this.isLoading = true;
    this.service.InvoicePermits().subscribe(data => {
      this.isLoading = false;
      this.InvoicePermitsReport = data;
      this.isInvoicePermitsVisible = true;
    });
  }

  runFirstComplianceReminder() {
    this.isLoading = true;
    this.service.FirstCompliance().subscribe(data => {
      this.isLoading = false;
      this.FirstComplianceReport = data;
      this.isFirstComplianceReport = true;
    });
  }

  runSecondComplianceReminder() {
    this.isLoading = true;
    this.service.SecondCompliance().subscribe(data => {
      this.isLoading = false;
      this.SecondComplianceReport = data;
      this.isSecondComplianceReport = true;
    });
  }

  runThirdComplianceReminder() {
    this.isLoading = true;
    this.service.ThirdCompliance().subscribe(data => {
      this.isLoading = false;
      this.ThirdComplianceReport = data;
      this.isThirdComplianceReport = true;
    });
  }

  runReturnsRecords() {
    this.isLoading = true;
    this.complianceservice.CreateComplianceLongTerm().subscribe(data => {
      this.isLoading = false;
      this.ComplianceReturnReport = data;
      this.isMonthyComplianceReturn = true;
    });
  }

  runReturnsNewRecords(){
    this.isLoading = true;
    this.complianceservice.CreateComplianceNewly().subscribe(data => {
      this.isLoading = false;
      this.ComplianceReturnNewReport = data;
      this.isMonthyComplianceNew = true;
    });
  }

  runCreateAnnualComplianceRecords(){
    this.isLoading = true;
    this.complianceservice.CreateAnnualComplianceRecords().subscribe(data => {
      this.isLoading = false;
      this.AnnualComplianceRecordsReport = data;
      this.isAnnualComplianceRecords = true;
    });
  }

  runCreateAnnualComplianceReminders(){
    this.isLoading = true;
    this.complianceservice.CreateAnnualComplianceReminders().subscribe(data => {
      this.isLoading = false;
      this.AnnualComplianceRemindersReport = data;
      this.isAnnualComplianceReminders = true;
    });
  }

  runCreateAnnualComplianceInvoices(){
    this.isLoading = true;
    this.complianceservice.CreateAnnualComplianceInvoices().subscribe(data => {
      this.isLoading = false;
      this.AnnualComplianceInvoicesReport = data;
      this.isAnnualComplianceInvoices = true;
    });
  }

  runCreateMonthlyComplianceRecords(){
    this.isLoading = true;
    this.complianceservice.CreateMonthlyComplianceRecords().subscribe(data => {
      this.isLoading = false;
      this.MonthlyComplianceReport = data;
      this.isMonthlyComplianceRecords = true;
    });
  }

  runCreateMonthlyComplianceReminders(){
    this.isLoading = true;
    this.complianceservice.CreateMonthlyComplianceReminders().subscribe(data => {
      this.isLoading = false;
      this.MonthlyComplianceReport = data;
      this.isMonthlyComplianceReminders = true;
    });
  }

}
